import { Component, OnInit, Output, Input, AfterViewInit, ViewChild, ElementRef, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { AuthorizationService } from '@src/app/helpers/authorization.service';
import { PersonmodalService } from './service/personmodal.service';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { RegistrationUser } from './model/registrationuser';
import { Data } from '@angular/router';
import { DatastoreService } from '@src/app/helpers/datastore/datastore.service';
import { PersonOrganization } from '@src/app/models/personorganization';


import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-personmodal',
  templateUrl: './personmodal.component.html',
  styleUrls: ['./personmodal.component.css']
})
export class PersonmodalComponent implements OnInit,OnChanges {
  @Output() personOutput = new EventEmitter<PersonOrganization>(true);
  @Output() personDetail:PersonOrganization;
  @Output() showSpinner:boolean;
  @Input() @Output() modalpersonId:string;
  @Input() @Output() bigimg:boolean;
  logosize:string;
  registrationUser:RegistrationUser;
  adminoptions:boolean = false;
  @Input() modalorgId:string;
  @Input() showPending:boolean;
  showkickedmember:boolean;
  showEditRelation:boolean;
  showKickMember:boolean;
  showSuccess:boolean;
  @Output() et_admin:boolean;
  relationerror:boolean;

  @ViewChild('closepersonmodal',{static: true}) closepersonmodal: ElementRef;
  spinnerTimeout: NodeJS.Timeout;
  constructor(
    private srv:PersonmodalService,
    private auth:AuthorizationService,
    private datastore:DatastoreService

    ) { }
  
  ngOnChanges(changes: SimpleChanges) {
   //console.log('on change fired',changes.modalpersonId.currentValue);
    if(changes.modalpersonId.currentValue){
      this.showSpinner =true;
      let pers = this.datastore.orgMembers.getValue().find(p => p.personId === changes.modalpersonId.currentValue);
      //this.srv.getPerson(changes.modalpersonId.currentValue,this.modalorgId ).pipe(untilDestroyed(this)).subscribe(pers =>{
       //console.log(pers);
        this.modalpersonId = changes.modalpersonId.currentValue;
        this.personDetail = pers;
        }
        this.spinnerTimeout = setTimeout(()=>{this.showSpinner = false;},100);
    
    
  }

   activeusertoggle(){
    this.personDetail.sendinvite =! this.personDetail.sendinvite;
  }

  ngOnInit() {
    this.et_admin = JSON.parse(SessionHelper.getPerson()).et_admin;
    this.showkickedmember=false;
    this.showSpinner =true;
    //console.log('on init fired');
    this.showSpinner =false;
  }
  resetModal(){
    // this.showSpinner =false;
    this.showkickedmember=false;
    // this.personDetail = new PersonOrganization;
    this.showSuccess = false;
    this.showKickMember = false;
    this.showEditRelation = false;
    // this.modalpersonId = "";
  }
  showPendingJoinersControls(){
    return this.showPending;
  }
  toggleEditRelation(){
    if(this.showKickMember) {
      this.showKickMember = !this.showKickMember;
      this.showEditRelation = !this.showEditRelation;
    }else
    this.showEditRelation = !this.showEditRelation;
  }
  
  toggleKickMember(){
    if(this.showEditRelation) {
      this.showEditRelation = !this.showEditRelation;
      this.showKickMember = !this.showKickMember;
    }else
    this.showKickMember = !this.showKickMember;
  }
  saveRelation(){
   //console.log('save relation',this.personDetail);
    this.personDetail.triggermade = undefined;
    this.relationerror = false;
    this.showSpinner = true;
    if(this.personDetail.member_function == null){
      this.showSpinner = false;
      this.relationerror = true;
    }else{
      this.srv.savePersonOrg(this.personDetail).pipe(untilDestroyed(this)).subscribe(result =>{
        this.showSpinner = false;
        //this.personOutput.emit(this.personDetail);
        this.resetModal();
        this.closepersonmodal.nativeElement.click();    
      });
    }
  }
  kickMember(){
    this.showSpinner = true;
    this.srv.kickMember(this.personDetail).pipe(untilDestroyed(this)).subscribe(result =>{
      this.showSpinner = false;
      this.showkickedmember=true;
      this.showSuccess = true;
      //TODO remove member from list
      this.personDetail.date_left = new Date().toISOString();
      //this.personOutput.emit(this.personDetail);
      this.closepersonmodal.nativeElement.click();
    });
  }
  get canChangeUserType(){
    return this.showPending ? false : this.auth.isAuthorized('orgassignadmin',this.modalorgId)
    this.showSpinner = false;
  }
  get canKickMember(){
    return this.showPending ? false : this.auth.isAuthorized('orgkickmember',this.modalorgId)
    this.showSpinner = false;
  }
  get canEditRelation(){
    return this.showPending ? false : this.auth.isAuthorized('orgeditmember',this.modalorgId)
    this.showSpinner = false;
  }
  toggleadminoptions(){
    this.adminoptions =! this.adminoptions;
  }
}
